import { Locale } from '../app/locale/resolveLocale';

export const landingCopy: Record<Locale, {
  brand: string;
  title: string;
  subtitle: string;
  start: string;
  howItWorks: string;
  languageToggle: string;
}> = {
  'zh-CN': {
    brand: '社交事故局',
    title: '测测你的社交反应人格',
    subtitle: '上滑逃避，下滑开麦，双击发梗。看看你在社交现场里会生成哪份社交事故档案。',
    start: '开始测试',
    howItWorks: '怎么玩？',
    languageToggle: 'English'
  },
  en: {
    brand: 'Social Reflex',
    title: 'Discover your social reaction type',
    subtitle: 'Swipe, tap, and choose your way through social moments to get a shareable Social Mishap Report.',
    start: 'Start test',
    howItWorks: 'How it works',
    languageToggle: '中文'
  }
};
